import _ from 'underscore';

import { FlowMapper } from '../../../flow/models/mappers/FlowMapper';
import { FlowOutputStepRunMapper } from '../../../flow/models/mappers/FlowOutputStepRunMapper';
import { FlowBasic } from '../../../flow/serverApi/types/Flow';
import { FlowOutputStep } from '../../../flow/serverApi/types/FlowOutputStep';
import { FlowOutputStepRun } from '../../../flow/serverApi/types/FlowOutputStepRun';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { MapperHelper } from '../../../ts/mappers/MapperHelper';
import { INamedItemInfo } from '../../../ts/models/resourceInfoParts';
import { IAlert } from '../../serverApi/types/IAlert';
import { IAlertListInfo } from '../IAlertInfo';

export module AlertListMapper {

  const M = MapperHelper;

  export function map(
    total: number,
    alerts: IAlert[],
    workbooks: _.Dictionary<INamedItemInfo>,
    datasources: _.Dictionary<INamedItemInfo>,
    flowOutputStepRuns: _.Dictionary<FlowOutputStepRun>,
    flowOutputSteps: _.Dictionary<FlowOutputStep>,
    flows: _.Dictionary<FlowBasic>,
  ): IAlertListInfo {
    return {
      total: total,
      alerts: _.map(alerts, (alert: IAlert) => {
        return {
          id: alert.id,
          statusCode: M.toNumber(alert.statusCode),
          taskId: alert.taskId,
          mostRecentFailureAt: M.toDate(alert.mostRecentFailureAt),
          lastSuccessAt: M.toDate(alert.lastSuccessAt),
          workbooks: _.map(alert.affectedWorkbookIds, (id) => workbooks[id]),
          datasource: datasources[alert.datasourceId],
          alertType: alert.alertType,
          suspended: alert.suspended,
          consecutiveFailureCount: alert.consecutiveFailureCount,
          flowId: alert.flowId,
           ...alert.alertType === 'FlowRunFailure' && alert.flowOutputStepRunId && flowOutputStepRuns[alert.flowOutputStepRunId] && {
           flowOutputStepRun: FlowOutputStepRunMapper.mapOneForAlert(flowOutputStepRuns[alert.flowOutputStepRunId], flowOutputSteps)
          },
          ...(alert.alertType === 'FlowRunFailure' || alert.alertType === 'FlowTasksSuspended') && alert.flowId && flows[alert.flowId] && {
            flow: FlowMapper.mapOneForAlert(flows[alert.flowId])
          },
          ...!!FeatureFlags.autoSuspendFlowTasksEnabled && alert.suspendedTasksCount && {
            suspendedTasksCount: alert.suspendedTasksCount
          },
        };
      })
    };
  }
}
